import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Grid, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  background-color: #f1f7f6;
  overflow: hidden;
  padding: 0;
`

export const Wrapper = styled(Container)`
  position: relative;
  padding-top: 5rem;
  padding-bottom: 5rem;
  ${({ theme }) => theme.breakpoints.down(1200)} {
    padding-top: 5rem;
    padding-bottom: 0;
  }
`

export const InfoContainer = styled.div`
  // ${({ theme }) => theme.breakpoints.up("md")} {
  //   margin-left: 3rem;
  // }
`

export const CustomGridContainer = styled(Grid)`
  border-radius: 16px;
  border: 1px solid rgba(193, 223, 216, 0.75);
  overflow: hidden;
`

export const FeatureContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 0.5rem;
  padding-right: 2rem;
  border: 0.5px solid rgba(193, 223, 216, 0.75);
  padding: 20px;
  height: 100%;

  &.remove-border {
    border-radius: 16px;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.tertiary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem(44)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(56)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(28)};
  text-align: center;
  max-width: 507px;
  margin-left: auto;
  margin-right: auto;
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(32)};
    line-height: ${({ theme }) => theme.typography.pxToRem(44)};
    font-weight: 500;
    max-width: unset;
  }
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(40)};

  &.feature {
    font-weight: 500;
    margin-bottom: 0;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-weight: 500;
  }
`

export const Image = styled(CustomImage)`
  width: 100% !important;
  min-width: 600px;
  max-width: 880px;
  position: absolute;
  bottom: -8px;
  right: -2rem;
  ${({ theme }) => theme.breakpoints.down(1200)} {
    position: relative;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    width: 160% !important;
    left: -120px;
  }
`

export const SwitchContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(44)};

  .MuiTypography-root {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    font-style: normal;
    font-weight: 600;
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
    letter-spacing: 0.18px;
    text-transform: uppercase;
  }

  .MuiSwitch-root {
    width: 80px !important;
    height: 60px !important;
    padding: 9 !important;

    &.bg-color {
      .MuiSwitch-track {
        background-color: ${({ theme }) =>
          theme.palette.tertiary.dark} !important;
        opacity: 1 !important;
      }
    }
  }

  .MuiSwitch-track {
    border-radius: 18px !important;
  }

  .MuiButtonBase-root {
    padding: 17px !important;
  }

  .Mui-checked {
    &.MuiButtonBase-root {
      color: white;
    }
  }

  .MuiSwitch-thumb {
    width: 25px;
    height: 25px;
  }
`
